import { render, staticRenderFns } from "./MatrizUnidadesAdministrativasTable.vue?vue&type=template&id=db5fa6e2&scoped=true&"
import script from "./MatrizUnidadesAdministrativasTable.vue?vue&type=script&lang=js&"
export * from "./MatrizUnidadesAdministrativasTable.vue?vue&type=script&lang=js&"
import style0 from "./MatrizUnidadesAdministrativasTable.vue?vue&type=style&index=0&id=db5fa6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5fa6e2",
  null
  
)

export default component.exports